module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part4"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "part5"
  }, [_vm._v("to the New Edition")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The following foundations and individuals gave generous support for the publication of this volume and volumes 8, 9, and 10 of "), _c('em', [_vm._v("The Churchill Documents")]), _vm._v(": the Lynde and Harry Bradley Foundation, Milwaukee, Wisconsin; the Earhart Foundation, Ann Arbor, Michigan; the late George B. Ferguson, Peoria, Arizona; Mr. and Mrs. Thomas N. Jordan, Jr., Healdsburg, California; Mr. and Mrs. Tim M. Roudebush, Lenexa, Kansas; Mr. and Mrs. Emil A. Voelz, Jr., Akron, Ohio; and the Saul N. Silbert Charitable Trust, Sun City, Arizona.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34776293","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ack.vue
// module id = 81
// module chunks = 0